"use strict";

var _classCallCheck = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var uuid_1 = require("uuid");

var AbstractMessage = function AbstractMessage(id) {
  _classCallCheck(this, AbstractMessage);

  this.id = id || "TM".concat(uuid_1.v4());
};

exports.AbstractMessage = AbstractMessage;